import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "../App";
import "../styles/application.css";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Fieldnote: #root element not found in the page shell.");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
